import React, { useContext } from "react";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import { QuizContext } from "../Quiz_Page/Context/QuizContext";

const Header = () => {
  const navigate = useNavigate();
  const { quizData } = useContext(QuizContext);
  const { name, Email } = quizData;

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <section className="h-wrapper">
      <div className="flexCenter innerWidth paddings h-container">
        <img
          src="business_light_energy_creative_idea_bulb_deal_money_ener_icon_250725.png"
          alt="No Photos"
          width={35}
        />

        <div className="flexCenter h-menu">
          <Link to="/">Login</Link>
          <Link to="/Quiz_home">Quiz</Link>
          {name && Email ? (
            <button className="button" onClick={handleLogout}>
              Log out
            </button>
          ) : (
            <button className="button">Log in</button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Header;
